module.exports = __webpack_public_path__ + "img/background.24984201.jpg";